import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Loader2, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

const Payment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { bookingData, service } = location.state || {};
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (!bookingData || !service) {
      navigate('/booking');
    }
  }, [bookingData, service, navigate]);

  const handlePayment = () => {
    // Mock Stripe payment flow
    setIsProcessing(true);
    
    // Simulate payment processing
    setTimeout(() => {
      setIsProcessing(false);
      toast.success('Payment successful! Booking confirmed.');
      navigate('/confirmation', { 
        state: { 
          bookingData, 
          service,
          confirmed: true 
        } 
      });
    }, 2000);
  };

  if (!bookingData || !service) {
    return null;
  }

  return (
    <div className="min-h-screen bg-zinc-950 pt-20">
      <div className="max-w-2xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold mb-8 text-zinc-100 text-center">Complete Payment</h1>
        
        <Card className="bg-zinc-900 border-zinc-800 mb-6">
          <CardHeader>
            <CardTitle className="text-zinc-100">Payment Summary</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="flex justify-between text-zinc-300">
                <span>{service.name}</span>
                <span>${service.price}</span>
              </div>
              <div className="border-t border-zinc-800 pt-4">
                <div className="flex justify-between text-xl font-bold text-zinc-100">
                  <span>Total</span>
                  <span>${service.price}</span>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-zinc-900 border-zinc-800 mb-6">
          <CardContent className="pt-6">
            <div className="bg-zinc-950 p-6 rounded-lg border border-zinc-800 mb-6">
              <p className="text-sm text-zinc-400 mb-4">
                <strong className="text-zinc-300">Note:</strong> This is a demo payment interface. 
                In production, this will integrate with Stripe for secure payment processing.
              </p>
              <div className="space-y-2 text-sm text-zinc-400">
                <p>✓ Secure payment processing</p>
                <p>✓ Booking confirmation email</p>
                <p>✓ 24-hour cancellation policy</p>
              </div>
            </div>

            <Button
              onClick={handlePayment}
              disabled={isProcessing}
              className="w-full bg-zinc-100 text-zinc-950 hover:bg-zinc-200 py-6 text-lg font-medium"
            >
              {isProcessing ? (
                <>
                  <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                  Processing Payment...
                </>
              ) : (
                <>
                  <CheckCircle2 className="w-5 h-5 mr-2" />
                  Pay ${service.price} - Confirm Booking
                </>
              )}
            </Button>
          </CardContent>
        </Card>

        <div className="text-center text-sm text-zinc-500">
          <p>Your payment information is secure and encrypted</p>
        </div>
      </div>
    </div>
  );
};

export default Payment;
